{
  "registerButton": "Register as a user",
  "registrationSucceeded": "Registration successful",
  "registrationCancelled": "Registration cancelled",
  "registrationFailed": "Error in the account creation process.",
  "createNewPassword": "Create a password",
  "createNewPasswordDescription": "Use this password to log in to the resident pages.",
  "createNewPasswordValidationErrorGeneric": "The password must meet all the requirements",
  "createNewPasswordValidationErrorMatcingPasswords": "The passwords do not match",
  "createNewPasswordValidationErrorLength": "At least 8 characters",
  "createNewPasswordValidationErrorNumber": "Number",
  "createNewPasswordValidationErrorSpecialCharacter": "Special character",
  "createNewPasswordValidationErrorUppercase": "Uppercase letter",
  "createNewPasswordValidationErrorLowercase": "Lowercase letter",
  "createNewPasswordValidationSectionHeader": "Strong password:",
  "createNewPasswordValidationSectionSubheader": "Characters such as ä, ö, and å cannot be used.",
  "createNewPasswordValidationErrorScandicLetters": "No characters å, ä or ö",
  "newPasswordLabel": "Password",
  "newPasswordAgainLabel": "Repeat the password",
  "confirmEmailHeader": "Confirm your email address",
  "confirmEmailError": "Unable to add your email address",
  "confirmEmailLabel": "Email address",
  "confirmEmailSubmit": "Confirm your email address",
  "confirmEmailDescription": "Your email address is your user ID for the resident pages.",
  "confirmEmailSubmitError": "An error occurred while confirming your email address",
  "confirmEmaiCancel": "Cancel",
  "verificationCodeError": "The code is invalid or has expired",
  "verificationCodeSubmit": "Confirm",
  "verificationCodeLabel": "Confirmation code",
  "verificationCodeDescription": "A confirmation code was sent to the address",
  "verificationCodeResendDescription": "If you have not received the code, wait a moment, check your spam folder or",
  "verificationCodeResendLink": "send the code again",
  "verificationCodeResendStatus": "A new code was sent at {{time}}",
  "verificationCodeResendError": "An error occurred while sending the confirmation code",
  "resendVerificationCode": {
    "linkText": "Send the confirmation code again here.",
    "success": "Your user account has been verified. You can now log in by entering your user name and password."
  },
  "ftnCallbackErrorMessage": "Error in the account creation process.",
  "ftnCallbackErrorDescription": "Try registering again. If needed, change the authentication method.",
  "ftnCallbackErrorBackButtonText": "Back to the first page",
  "continueRegistrationInfo4": "If you want to change the email address",
  "continueRegistrationInfo3": "If you did not receive the code (wait a moment and also check your spam folder) or if it has expired",
  "continueRegistrationInfo2": "You have received a confirmation code at <strong>{{email}}</strong>.",
  "continueRegistrationInfo1": "Your registration was previously interrupted. You still need to confirm your email address.",
  "continueRegistrationHeader": "Welcome back!",
  "resetRegistrationLinkText": "start the registration from the beginning",
  "chooseAuthHeader": "Register as a user",
  "chooseAuthFtn": "Bank credentials or mobile ID",
  "chooseAuthPassport": "Passport or ID card",
  "invitationLoadError": "Failed to load the invitation.",
  "invitationExpiredTitle": "The invitation has expired",
  "invitationExpiredDescription": "This registration invitation has expired. Please request a new invitation.",
  "invitationAlreadyRegisteredTitle": "Account already created",
  "invitationAlreadyRegisteredDescription": "A user account has already been created for this invitation. You can log in.",
  "invitationRegisterError": "Registration failed.",
  "invitationCreatePasswordHeader": "Create a password",
  "invitationCreatePasswordDescription": "You are creating a user account for the email address {{email}}. Set a password to log in to the resident pages in the future.",
  "registrationWrongDomain": "Start the registration at: {{url}}."
}
